import { Link } from 'react-router-dom';
import { categoryContentMap } from '@/mocks/categories';

const hotContent = [
  { ...categoryContentMap.variety[0], coverUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20thumbnail%20for%20Chinese%20variety%20show%2C%20warm%20peach%20golden%20lighting%2C%20professional%20entertainment%20media%20production%20aesthetic%2C%20clean%20composition%20with%20soft%20shadows%2C%20modern%20stage%20lighting%20style&width=640&height=360&seq=hot-v1&orientation=landscape' },
  { ...categoryContentMap.variety[1], coverUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20thumbnail%20for%20Chinese%20reality%20TV%20show%2C%20warm%20coral%20lighting%2C%20celebrity%20entertainment%20production%20aesthetic%2C%20clean%20composition%2C%20modern%20variety%20show%20style&width=640&height=360&seq=hot-v2&orientation=landscape' },
  { ...categoryContentMap.movie[0], coverUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20thumbnail%20science%20fiction%20film%2C%20warm%20golden%20cinematic%20lighting%2C%20professional%20film%20production%20aesthetic%2C%20clean%20composition%20with%20dramatic%20shadows%2C%20blockbuster%20style&width=640&height=360&seq=hot-m1&orientation=landscape' },
  { ...categoryContentMap.movie[1], coverUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20thumbnail%20Chinese%20historical%20drama%2C%20warm%20peach%20and%20golden%20lighting%2C%20traditional%20Chinese%20aesthetic%2C%20professional%20film%20production%2C%20clean%20composition%20with%20soft%20shadows&width=640&height=360&seq=hot-m2&orientation=landscape' },
  { ...categoryContentMap.music[0], coverUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20thumbnail%20Chinese%20music%20performance%2C%20warm%20peach%20stage%20lighting%2C%20concert%20production%20aesthetic%2C%20clean%20composition%2C%20modern%20entertainment%20style&width=640&height=360&seq=hot-mu1&orientation=landscape' },
  { ...categoryContentMap.music[1], coverUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20thumbnail%20classical%20music%20orchestra%2C%20warm%20golden%20lighting%2C%20concert%20hall%20production%20aesthetic%2C%20clean%20composition%2C%20elegant%20classical%20style&width=640&height=360&seq=hot-mu2&orientation=landscape' },
  { ...categoryContentMap.game[0], coverUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20thumbnail%20video%20game%20gameplay%2C%20warm%20peach%20and%20golden%20lighting%2C%20gaming%20production%20aesthetic%2C%20clean%20composition%2C%20modern%20esports%20style&width=640&height=360&seq=hot-g1&orientation=landscape' },
  { ...categoryContentMap.game[1], coverUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20thumbnail%20esports%20competition%2C%20warm%20golden%20stage%20lighting%2C%20gaming%20arena%20production%20aesthetic%2C%20clean%20composition%2C%20professional%20esports%20style&width=640&height=360&seq=hot-g2&orientation=landscape' },
];

export default function ContentSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
              热门内容推荐
            </h2>
            <p className="mt-2 text-foreground-500 text-sm">
              精选优质内容，发现更多精彩
            </p>
          </div>
          <Link
            to="/category/variety"
            className="mt-3 sm:mt-0 px-5 py-2 text-sm font-medium text-primary-500 border border-primary-300 rounded-full hover:bg-primary-50 transition-all whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop>
          {hotContent.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="group rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.coverUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-background-50 text-xs">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full">
                    {item.category}
                  </span>
                  <span><i className="ri-eye-line mr-1"></i>{item.views}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}